import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoMarketCarBoxTransactionLogListRequest,
  LogControllerDtoMarketCarTransactionLogListRequest,
  LogControllerDtoMarketGemTransactionLogListRequest,
  LogControllerDtoMarketItemTransactionLogListRequest,
  LogControllerDtoMarketPilotTransactionLogListRequest,
  LogControllerDtoMarketPilotTransactionLogListResponse,
  PerplayLogApi
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import {
  MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST,
  MARKET_CAR_LOG_INFO_LIST_REQUEST,
  MARKET_GEM_LOG_INFO_LIST_REQUEST,
  MARKET_ITEMS_LOG_INFO_LIST_REQUEST, MARKET_PILOT_LOG_INFO_LIST_REQUEST,
} from '../../constants/log/marketTransactionLogConstants';
import LogControllerDtoMarketCarTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoMarketCarTransactionLogListResponse';
import LogControllerDtoMarketCarBoxTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoMarketCarBoxTransactionLogListResponse';
import LogControllerDtoMarketGemTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoMarketGemTransactionLogListResponse';
import LogControllerDtoMarketItemTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoMarketItemTransactionLogListResponse';
const api = new PerplayLogApi(config.API_CLIENT);

function* marketCarLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoMarketCarTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.nftUid = payload.nftUid;
    requestData.buyerAccount = payload.buyerAccount;
    requestData.sellerAccount = payload.sellerAccount;
    requestData.vehicleType = payload.vehicleType;
    requestData.vehicleGrade = payload.vehicleGrade;
    requestData.vehicleSeal = payload.vehicleSeal;
    requestData.minLevel = payload.minLevel;
    requestData.maxLevel = payload.maxLevel;
    requestData.isPlus = payload.isPlus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMarketCarTransactionLogListPost({ logControllerDtoMarketCarTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMarketCarTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* marketCarBoxLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoMarketCarBoxTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.nftUid = payload.nftUid;
    requestData.buyerAccount = payload.buyerAccount;
    requestData.sellerAccount = payload.sellerAccount;
    requestData.grade = payload.grade;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMarketCarBoxTransactionLogListPost({ logControllerDtoMarketCarBoxTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMarketCarBoxTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* marketGemLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoMarketGemTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.buyerAccount = payload.buyerAccount;
    requestData.sellerAccount = payload.sellerAccount;
    requestData.isGemRed = payload.isGemRed;
    requestData.isGemBlue = payload.isGemBlue;
    requestData.isGemGreen = payload.isGemGreen;
    requestData.isGemYellow = payload.isGemYellow;
    requestData.level = payload.level;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMarketGemTransactionLogListPost({ logControllerDtoMarketGemTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMarketGemTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* marketItemsLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoMarketItemTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.buyerAccount = payload.buyerAccount;
    requestData.sellerAccount = payload.sellerAccount;
    requestData.level = payload.level;
    requestData.materialType = payload.materialType;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMarketItemTransactionLogListPost({ logControllerDtoMarketItemTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMarketItemTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}


function* marketPilotLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoMarketPilotTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.nftUid = payload.nftUid;
    requestData.buyerAccountNo = Number(payload.buyerAccount);
    requestData.sellerAccountNo = Number(payload.sellerAccount);
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMarketPilotTransactionLogListPost({ logControllerDtoMarketPilotTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMarketPilotTransactionLogListResponse);

    // if (data.resultCode !== 200) {
    //   throw new Error(getErrorMessage(data));
    // }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* marketTransactionLogRootSaga() {
  yield all([
    takeEvery(MARKET_CAR_LOG_INFO_LIST_REQUEST, marketCarLogListRequestSaga),
    takeEvery(MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST, marketCarBoxLogListRequestSaga),
    takeEvery(MARKET_GEM_LOG_INFO_LIST_REQUEST, marketGemLogListRequestSaga),
    takeEvery(MARKET_ITEMS_LOG_INFO_LIST_REQUEST, marketItemsLogListRequestSaga),
    takeEvery(MARKET_PILOT_LOG_INFO_LIST_REQUEST, marketPilotLogListRequestSaga),
  ])
}

const marketTransactionLogSaga = [
  fork(marketTransactionLogRootSaga),
];

export default marketTransactionLogSaga;
